module.exports = __webpack_public_path__ + "static/media/fortlev_solar_vetor_3.a8ec07b4.svg";